import moment from 'moment'
import percentLabelsMixin from './percentLabels'

const { jsPDF } = require('jspdf')

const PAGE_MARGIN = 40
const ROW_HEIGHT = 22
const COUNT_COLUMN_WIDTH = 90
const PERCENT_COLUMN_WIDTH = 90
const HEADER_FILL = [155, 27, 48]
const TOTAL_FILL = [246, 245, 243]
const BORDER_COLOR = [230, 230, 230]

function buildNationalityProfilePdf(schoolName, nationalities, percentLabels) {
  const doc = new jsPDF('p', 'pt', 'a4')
  const pageWidth = doc.internal.pageSize.getWidth()
  const pageHeight = doc.internal.pageSize.getHeight()
  const tableWidth = pageWidth - PAGE_MARGIN * 2
  const countX = PAGE_MARGIN + tableWidth - PERCENT_COLUMN_WIDTH - 10
  const percentX = PAGE_MARGIN + tableWidth - 10
  const nameX = PAGE_MARGIN + 10
  const totalStudents = nationalities.reduce((sum, nationality) => sum + nationality.count, 0)

  let y = PAGE_MARGIN

  doc.setFont('helvetica', 'bold')
  doc.setFontSize(16)
  doc.setTextColor(26, 26, 26)
  doc.text(`${schoolName} Nationality Profile`, PAGE_MARGIN, y + 12)
  doc.setFont('helvetica', 'normal')
  doc.setFontSize(10)
  doc.setTextColor(107, 107, 107)
  y += 50

  const drawRow = (cells, { fill, textColor = [51, 51, 51], bold = false } = {}) => {
    if (fill) {
      doc.setFillColor(...fill)
      doc.rect(PAGE_MARGIN, y, tableWidth, ROW_HEIGHT, 'F')
    }
    doc.setDrawColor(...BORDER_COLOR)
    doc.line(PAGE_MARGIN, y + ROW_HEIGHT, PAGE_MARGIN + tableWidth, y + ROW_HEIGHT)
    doc.setFont('helvetica', bold ? 'bold' : 'normal')
    doc.setFontSize(10)
    doc.setTextColor(...textColor)

    const textY = y + ROW_HEIGHT / 2 + 3.5
    const maxNameWidth = tableWidth - COUNT_COLUMN_WIDTH - PERCENT_COLUMN_WIDTH - 20
    doc.text(doc.splitTextToSize(cells[0], maxNameWidth)[0], nameX, textY)
    doc.text(cells[1], countX, textY, { align: 'right' })
    doc.text(cells[2], percentX, textY, { align: 'right' })
    y += ROW_HEIGHT
  }

  const drawHeader = () => drawRow(['Nationality', 'Total', 'Percentage'], { fill: HEADER_FILL, textColor: [255, 255, 255], bold: true })

  drawHeader()
  nationalities.forEach((nationality, index) => {
    // Leave room for the total row on the last page
    if (y + ROW_HEIGHT * 2 > pageHeight - PAGE_MARGIN) {
      doc.addPage()
      y = PAGE_MARGIN
      drawHeader()
    }
    drawRow([nationality.name, String(nationality.count), percentLabels[index]])
  })
  drawRow(['Total', String(totalStudents), '100%'], { fill: TOTAL_FILL, textColor: [26, 26, 26], bold: true })

  return doc
}

// Expects the component to provide `schoolName` and `nationalities` ([{ name, count }] in display order)
export default {
  mixins: [percentLabelsMixin],
  methods: {
    downloadNationalityProfilePdf() {
      const percentLabels = this.toPercentLabels(this.nationalities.map(nationality => nationality.count))
      const doc = buildNationalityProfilePdf(this.schoolName, this.nationalities, percentLabels)
      const fileSchoolName = this.schoolName.replace(/[^a-z0-9]+/gi, '_').replace(/^_|_$/g, '')
      doc.save(`${fileSchoolName}_Nationality_Profile_${moment().format('YYYYMMDD')}.pdf`)
    },
  },
}
